import PropTypes from 'prop-types';
import { BackButton } from '@spotahome/ui-library';

import './ContactUsHeader.scss';

const noop = () => {};

const ContactUsHeader = ({ title, onBack = noop, isInvisible = false }) => {
  if (isInvisible) {
    return <div className="contact-us-header" />;
  }

  return (
    <div className="contact-us-header">
      <BackButton
        color="white"
        className="contact-us-header__icon"
        onClick={onBack}
      />
      <span
        className="contact-us-header__title"
        type="button"
        onClick={onBack}
        role="button"
        tabIndex={0}
      >
        {title}
      </span>
    </div>
  );
};

ContactUsHeader.propTypes = {
  title: PropTypes.string.isRequired,
  isInvisible: PropTypes.bool,
  onBack: PropTypes.func
};

export default ContactUsHeader;
